import React, { useRef, useState } from "react";
import { Form, Label, Input, FormFeedback } from "reactstrap";
import Buttons from "../Buttons";
import { emailIsValid } from "../../../../../helpers";

const EmailForm = ({ setCurrentForm, handleForm, onClose }) => {
  const emailRef = useRef();
  const [emailState, setEmailState] = useState("")

  const handleSubmit = () => {
    const email = emailRef.current.value;

    if (!emailIsValid(email)) {
      setEmailState("error")
      return
    };

    handleForm({ email }, "checkEmail");
  };

  return (
    <>
      <Form className="dyna-form login-form">
        <Label for="email" className="login-form-label required">
          Email:
        </Label>
        <Input
          innerRef={emailRef}
          className="mg-btm-10"
          type="email"
          name="email"
          invalid={emailState === "error"}
          id="email"
          placeholder="Enter your email"
        />
        <FormFeedback>
          Please input a correct email.
        </FormFeedback>
      </Form>
      <Buttons
        type={"EmailForm"}
        setCurrentForm={setCurrentForm}
        onSubmit={handleSubmit}
        onClose={onClose}
      />
    </>
  );
};

export default EmailForm;
